import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Tooltip, notification, Row, Form, Input, Col, Select, Collapse, Popconfirm, Card, Space, Tag, Modal, Table } from "antd";
import {
  InfoCircleFilled, DeleteOutlined, ClearOutlined, MinusCircleTwoTone, SwapOutlined, FormOutlined,
  DashboardOutlined, SunOutlined, CloudOutlined, FireOutlined, CaretDownOutlined, CloseOutlined
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import StockApi from "../common/Apis/StockApi";
import EditStock from "../common/Models/GoodInward/EditStock";
import AddWasteProduct from "../common/Models/Waste/AddWasteProduct";
import AdjustStockModal from "./AdjustStockModal";
import StorageListApi from "../common/Apis/StorageListApi";
import StorageDetailModal from "../common/Models/Stock/StorageDetailModal";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

// import StorageDetailModal from "./StorageDetailModal"; // Import the new component
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const CURRENCY = decodedToken?.currency === "USD" ? "$" : "€";

const { Panel } = Collapse;

// Temperature classification function
const getTemperatureCategory = (isHot) => {
  if (isHot) return {
    category: "Hot Storage",
    color: "#ff4d4f",
    icon: <FireOutlined />,
    gradient: "linear-gradient(135deg, #ff4d4f 0%, #ff7a45 100%)"
  };
  else return {
    category: "Cold Storage",
    color: "#1890ff",
    icon: <CaretDownOutlined />,
    gradient: "linear-gradient(135deg, #1890ff 0%, #36cfc9 100%)"
  };
};

// Temperature ranges for agenda
const temperatureRanges = [
  { range: "Cold Storage", color: "#1890ff", icon: <CaretDownOutlined /> },
  { range: "Hot Storage", color: "#ff4d4f", icon: <FireOutlined /> }
];

const StockList = () => {
  let navigate = useNavigate();
  const { Content } = Layout;

  const [Stocks, setStocks] = useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const [formPaginate] = Form.useForm();
  const [FilterEnable, setFilterEnable] = useState(false);
  const [totalElements, setTotalElements] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [filterStock, setFilterStock] = useState([{ title: "", answerType: "", name: "" }]);

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");
  const [modalwasteVisible, setModalwasteVisible] = useState(false);
  const [modalwasteData, setModalwasteData] = useState("");
  const [modalwasteId, setmodalwasteId] = useState(null);

  const [modalAdjustVisible, setModalAdjustVisible] = useState(false);
  const [modalAdjustData, setModalAdjustData] = useState(null);
  const [modalAdjustId, setModalAdjustId] = useState(null);
  const [modalAdjustProductPayload, setModalAdjustProductPayload] = useState(null);
  const [stockId, setStockId] = useState(null);
  const [initStockQty, setInitStockQty] = useState(null);
  const [batchCode, setBatchCode] = useState(null);
  const [previousQuantity, setPreviousQuantity] = useState(null);


  // New state for storage modal
  const [storageModalVisible, setStorageModalVisible] = useState(false);
  const [selectedStorage, setSelectedStorage] = useState(null);
  const [storageRefreshTrigger, setStorageRefreshTrigger] = useState(0);

  const [Storages, setStorage] = React.useState([]);

  const handleAdjustStock = (ProductID, itemId, productPayload = null) => {
    setModalAdjustId(ProductID);
    setStockId(itemId);
    setModalAdjustProductPayload(productPayload);
    StockApi.SingleStock(itemId)
      .then((res) => {
        setModalAdjustData(res.payload);
        setBatchCode(res.batchCode);
      })
      .catch(console.log);
    setModalAdjustVisible(true);
  };

  const handleAdjustCloseModal = () => {
    setModalAdjustVisible(false);
    setModalAdjustData(null);
    setModalAdjustId(null);
    setModalAdjustProductPayload(null);
  };

  // Handle storage card click
  const handleStorageClick = (storage) => {
    setSelectedStorage(storage);
    setStorageModalVisible(true);
  };

  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 800);
  }, []);

  const getStorage = useCallback(() => {
    StorageListApi.ListStorage(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setStorage(response.payloadDto);
        setTotalElements(response.totalElements);
        setSelectedStorage((prev) => {
          if (!prev?.id) return prev;
          return response.payloadDto.find((storageItem) => storageItem.id === prev.id) || prev;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit]);

  const refreshStockData = useCallback(() => {
    StockApi.ListStock(PaginatePage, PaginateLimit)
      .then((res) => {
        setStocks(res.payloadDto);
        settotalPages(res.totalPages);
        setTotalElements(res.totalElements);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit]);

  const refreshStorageData = useCallback(() => {
    PageLoading();
    StorageListApi.ListStorage(PaginatePage, PaginateLimit)
      .then((response) => {
        setStorage(response.payloadDto);
        settotalPages(response.totalPages);
        setTotalElements(response.totalElements);
        setSelectedStorage((prev) => {
          if (!prev?.id) return prev;
          return response.payloadDto.find((storageItem) => storageItem.id === prev.id) || prev;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit, PageLoading]);

  const refreshAllData = useCallback(() => {
    PageLoading();
    Promise.all([
      StockApi.ListStock(PaginatePage, PaginateLimit),
      StorageListApi.ListStorage(PaginatePage, PaginateLimit),
    ])
      .then(([stockResponse, storageResponse]) => {
        setStocks(stockResponse.payloadDto);
        settotalPages(stockResponse.totalPages || storageResponse.totalPages);
        setTotalElements(stockResponse.totalElements || storageResponse.totalElements);
        setStorage(storageResponse.payloadDto);
        setSelectedStorage((prev) => {
          if (!prev?.id) return prev;
          return storageResponse.payloadDto.find((storageItem) => storageItem.id === prev.id) || prev;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [PaginatePage, PaginateLimit, PageLoading]);

  const paginatedData = Storages;

  const formRef = useRef(null);
  formPaginate.setFieldsValue({ paginate: PaginateLimit });

  // -------- Pagination & API calls --------
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({ paginate: value });
    StockApi.ListStock(0, value)
      .then((res) => {
        settotalPages(res.totalPages);
        setStocks(res.payloadDto);
        setTotalElements(res.totalElements);

      })
      .catch(console.log);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1;
    StockApi.ListStock(pageNew, PaginateLimit)
      .then((res) => {
        setStocks(res.payloadDto);
        setPaginatePage(pageNew);
        settotalPages(res.totalPages);
        setTotalElements(res.totalElements);

      })
      .catch(console.log);
  };

  useEffect(() => {
    getStorage();
    PageLoading();
    getStorage();
  }, [PageLoading, getStorage]);

  // -------- Filter Handlers --------
  const handleRemovefilterStock = (index) => {
    const newFilterStock = [...filterStock];
    newFilterStock.splice(index, 1);
    setFilterStock(newFilterStock);
    if (index === 0) getStorage();
  };

  const handleClear = () => {
    getStorage();
    PageLoading();
    setFilterEnable(false);
    setFilterStock([{ title: "", answerType: "", name: "" }]);
  };

  const handleAddfilterStock = () => setFilterStock([...filterStock, { title: "", answerType: "", name: "" }]);

  const handleChangeTitle = (index, value) => {
    const newFilterStock = [...filterStock];
    newFilterStock[index].title = value;
    setFilterStock(newFilterStock);
  };

  const handleChangeAnswertype = (index, value) => {
    const newFilterStock = [...filterStock];
    newFilterStock[index].answerType = value;
    setFilterStock(newFilterStock);
  };

  const handleChangename = (index, value) => {
    const newFilterStock = [...filterStock];
    newFilterStock[index].name = value;
    setFilterStock(newFilterStock);
  };

  const handleSubmit = () => {
    setFilterEnable(true);
    PageLoading();
    let query = filterStock
      .map((obj) => {
        if (obj.answerType === "%") return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        else if (obj.answerType === "=") return `${obj.title}${obj.answerType}${obj.name}`;
        else return `${obj.title}=${obj.name}`;
      })
      .join("&");

    let batchcode = query.replace("batchCode=", "");

    StockApi.ListBatchCode(batchcode)
      .then((res) => setStocks(res.payloadDto))
      .catch(() => setStocks([]));
  };

  // -------- Stock Modals & Delete --------
  const handleDeleteStock = (StockID) => {
    StockApi.DeleteStock(StockID)
      .then(() => {
        notification.success({ message: "Deleted Successfully" });
        PageLoading();
        getStorage();
      })
      .catch((err) => {
        notification.error({ message: err.apiError?.message || "Error" });
      });
  };

  const [totalStocks, setTotalStocks] = useState({
  totalCost: 0,
  totalItems: 0,
  totalStorageUnits: 0
});

// Calculate totals when Storages data changes
useEffect(() => {
  if (Storages.length > 0) {
    const filteredStorages = Storages.filter(
      (option) =>
        !(option.temperatureMinInCelsius === 0 &&
          option.temperatureMaxInCelsius === 0)
    );
    
    const totalCost = filteredStorages.reduce((sum, storage) => {
      return sum + (storage?.totalStockValue || 0);
    }, 0);
    
    const totalItems = filteredStorages.reduce((sum, storage) => {
      return sum + (storage?.productStockSummaryList?.length || 0);
    }, 0);
    
    setTotalStocks({
      totalCost: totalCost,
      totalItems: totalItems,
      totalStorageUnits: filteredStorages.length
    });
  }
}, [Storages]);

  const handleOpenEditModal = (StockID) => {
    StockApi.SingleStock(StockID)
      .then((res) => setModalEditData(res.payload))
      .catch(console.log);
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => setModalEditVisible(false);

  const handleWasteStock = (ProductID, itemId) => {
    setmodalwasteId(ProductID);
    StockApi.SingleStock(itemId)
      .then((res) => setModalwasteData(res.payload))
      .catch(console.log);
    setModalwasteVisible(true);
  };
  const handlwasteCloseModal = () => {
    setModalwasteVisible(false);
    setModalwasteData("");
    setmodalwasteId(null);
  };

  const handleWasteSuccess = () => {
  // Close the waste modal
  setModalwasteVisible(false);
  setModalwasteData("");
  setmodalwasteId(null);
  
  // Refresh all data without page reload
  refreshAllData();
  
  // Trigger storage detail modal refresh if open
  setStorageRefreshTrigger(prev => prev + 1);
  
  // Also refresh storage data specifically
  refreshStorageData();
};

  const handleGoBack = () => navigate(-1);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(parseInt(date, 10));
    return d.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" });
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && <div className="spinner-overlay"><div className="spinner"></div></div>}

        <div style={{
          paddingLeft: "50px",
          background: "#f0f2f5",
          borderBottom: "1px solid #e8e8e8",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px"
        }}>
          <div>
            <span style={{ fontWeight: 600, fontSize: "20px", marginRight: "20px" }}>
              Total Storage Units: {totalStocks.totalStorageUnits}
            </span>
            <span style={{ fontWeight: 600, fontSize: "20px", color: "#1890ff" }}>
              Total Cost: {CURRENCY} {totalStocks.totalCost.toFixed(2)}
            </span>
          </div>
        </div>

        {/* Storage Cards Section */}
        <Content style={{
          margin: "14px 16px 0",
          padding: "30px",
          background: "#f0f2f5",
        }}>
          <div className="storage-section">
            {/* Temperature Agenda/Legend */}


            {Storages.length > 0 ? (
              <Row gutter={[16, 16]}>
                {Storages.filter(
                  (option) =>
                    !(option.temperatureMinInCelsius === 0 &&
                      option.temperatureMaxInCelsius === 0)
                ).map((storage) => {
                  const isHotStorage = storage?.hot === true;
                  const tempCategory = getTemperatureCategory(isHotStorage);

                  return (
                    <Col xs={24} sm={12} md={8} lg={6} key={storage.id}>
                      <Card
                        hoverable
                        onClick={() => handleStorageClick(storage)}
                        title={
                          <div style={{ display: 'flex', flexDirection: 'column', color: 'white' }}>
                            <span style={{ fontSize: '16px', fontWeight: 600 }}>
                              {storage?.name}
                            </span>

                            <span style={{ fontSize: '13px', opacity: 0.9 }}>
                              Total Cost: {CURRENCY + " " + storage?.totalStockValue?.toFixed(2)}
                            </span>
                          </div>
                        }
                        style={{
                          minHeight: '200px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          cursor: 'pointer'
                        }}
                        headStyle={{
                          background: tempCategory.gradient,
                          color: 'white',
                          borderTopLeftRadius: '8px',
                          borderTopRightRadius: '8px',
                          padding: '16px 24px'
                        }}
                        bodyStyle={{ padding: '16px 24px' }}
                      >

                        <p style={{ marginBottom: '8px' }}>
                          <strong>Temperature Range</strong>
                          <br />
                          <span style={{
                            color: tempCategory.color,
                            fontWeight: 'bold'
                          }}>
                            {isHotStorage ? "N/A" : `${storage?.temperatureMinInCelsius}°C - ${storage?.temperatureMaxInCelsius}°C`}
                          </span>
                        </p>

                        <p style={{ marginBottom: '8px' }}>
                          <strong>Department</strong>
                          <br />
                          {storage?.institutionDTO?.institutionName || 'N/A'}
                        </p>

                        <p style={{ marginBottom: '8px' }}>
                          <strong>Alert Enabled</strong>
                          <br />
                          <Tag color={storage?.alertTrigger ? "success" : "default"}>
                            {storage?.alertTrigger ? "Yes" : "No"}
                          </Tag>
                        </p>

                        {storage?.location && (
                          <p style={{ marginBottom: '0' }}>
                            <strong>Location:</strong>
                            <br />
                            {storage.location}
                          </p>
                        )}
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '40px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <p style={{ fontSize: '16px', color: '#8c8c8c' }}>
                  No storage units available
                </p>
              </div>
            )}

            {/* Pagination for Storages */}
            {paginatedData.length > 0 && (
              <div style={{
                marginTop: '20px',
                padding: '20px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {paginatedData.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={PaginatetotalPages}
                  onPageChange={handlePageChange}
                  maxVisiblePages={5}
                  showPageInfo={true}
                  totalItems={totalElements}
                  pageSize={PaginateLimit}
                />
            )}
              </div>
            )}
          </div>
        </Content>

        {/* Storage Detail Modal Component */}
        <StorageDetailModal
          visible={storageModalVisible}
          onClose={() => setStorageModalVisible(false)}
          selectedStorage={selectedStorage}
          productStockSummaryList={selectedStorage?.productStockSummaryList || []} // Pass the product summary data
          decodedToken={decodedToken}
          onDeleteStock={handleDeleteStock}
          onWasteStock={handleWasteStock}
          onAdjustStock={handleAdjustStock}
          refreshTrigger={storageRefreshTrigger}
        />

        <EditStock visible={modalEditVisible} onClose={handlEditeCloseModal} ProductDetails={modalEditData} />
        {modalwasteVisible && 
        <AddWasteProduct 
        visible={modalwasteVisible} 
        onClose={handlwasteCloseModal} 
        ProductDetails={modalwasteData} 
        ProductId={modalwasteId} 
        onWasteSuccess={handleWasteSuccess} 
        />
        }
        
        <AdjustStockModal
          visible={modalAdjustVisible}
          onClose={handleAdjustCloseModal}
          stockDetails={modalAdjustData}
          stockId={stockId}
          productPayload={modalAdjustProductPayload}
          listStockData={Stocks}
          onAdjustSuccess={() => {
            refreshAllData();
            setStorageRefreshTrigger((prev) => prev + 1);
          }}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default StockList;